import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../utils/api';

const Header = ({ selectedCity, onCityChange }) => {
  const [cities] = useState(api.getCities());
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isActive = (path) => location.pathname === path;

  const headerStyle = {
    backgroundColor: 'var(--navy-blue)',
    color: 'var(--white)',
    padding: '16px 0',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  };

  const navStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative'
  };

  const logoStyle = {
    fontSize: isMobile ? '24px' : '28px',
    fontWeight: '700',
    color: 'var(--white)',
    fontFamily: 'Comfortaa, cursive'
  };

  const desktopMenuStyle = {
    display: isMobile ? 'none' : 'flex',
    alignItems: 'center',
    gap: '24px'
  };

  const mobileMenuStyle = {
    display: isMobile && isMenuOpen ? 'flex' : 'none',
    flexDirection: 'column',
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: 'var(--navy-blue)',
    padding: '20px',
    gap: '16px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
  };

  const hamburgerStyle = {
    display: isMobile ? 'flex' : 'none',
    flexDirection: 'column',
    cursor: 'pointer',
    gap: '4px',
    padding: '8px'
  };

  const hamburgerLineStyle = {
    width: '25px',
    height: '3px',
    backgroundColor: 'var(--white)',
    transition: 'all 0.3s ease',
    transformOrigin: 'center'
  };

  const linkStyle = {
    color: 'var(--white)',
    fontFamily: 'Comfortaa, cursive',
    fontWeight: '500',
    padding: '8px 16px',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'block'
  };

  const activeLinkStyle = {
    ...linkStyle,
    backgroundColor: 'var(--baby-blue)',
    color: 'var(--navy-blue)'
  };

  const selectStyle = {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '2px solid var(--baby-blue)',
    backgroundColor: 'var(--white)',
    color: 'var(--navy-blue)',
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    minWidth: isMobile ? '100%' : '150px'
  };

  return (
    <header style={headerStyle}>
      <div className="container">
        <nav style={navStyle}>
          <Link to="/" style={logoStyle}>
            Kolay Servis
          </Link>
          
          <div style={hamburgerStyle} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <div style={{
              ...hamburgerLineStyle,
              transform: isMenuOpen ? 'rotate(45deg) translate(6px, 6px)' : 'none'
            }}></div>
            <div style={{
              ...hamburgerLineStyle,
              opacity: isMenuOpen ? 0 : 1
            }}></div>
            <div style={{
              ...hamburgerLineStyle,
              transform: isMenuOpen ? 'rotate(-45deg) translate(6px, -6px)' : 'none'
            }}></div>
          </div>

          <div style={desktopMenuStyle}>
            <Link to="/" style={isActive('/') ? activeLinkStyle : linkStyle}>
              Ana Sayfa
            </Link>
            <Link to="/firma-ekle" style={isActive('/firma-ekle') ? activeLinkStyle : linkStyle}>
              Firma Ekle
            </Link>
            <Link to="/iletisim" style={isActive('/iletisim') ? activeLinkStyle : linkStyle}>
              İletişim
            </Link>
            <Link to="/vizyonumuz" style={isActive('/vizyonumuz') ? activeLinkStyle : linkStyle}>
              Vizyonumuz
            </Link>
            
            <select 
              style={selectStyle}
              value={selectedCity}
              onChange={(e) => onCityChange(e.target.value)}
            >
              <option value="">Tüm Şehirler</option>
              {cities.map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>

          <div style={mobileMenuStyle}>
            <Link 
              to="/" 
              style={isActive('/') ? activeLinkStyle : linkStyle}
              onClick={() => setIsMenuOpen(false)}
            >
              Ana Sayfa
            </Link>
            <Link 
              to="/firma-ekle" 
              style={isActive('/firma-ekle') ? activeLinkStyle : linkStyle}
              onClick={() => setIsMenuOpen(false)}
            >
              Firma Ekle
            </Link>
            <Link 
              to="/iletisim" 
              style={isActive('/iletisim') ? activeLinkStyle : linkStyle}
              onClick={() => setIsMenuOpen(false)}
            >
              İletişim
            </Link>
            <Link 
              to="/vizyonumuz" 
              style={isActive('/vizyonumuz') ? activeLinkStyle : linkStyle}
              onClick={() => setIsMenuOpen(false)}
            >
              Vizyonumuz
            </Link>
            
            <select 
              style={selectStyle}
              value={selectedCity}
              onChange={(e) => {
                onCityChange(e.target.value);
                setIsMenuOpen(false);
              }}
            >
              <option value="">Tüm Şehirler</option>
              {cities.map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;